import React, { useEffect, useRef, useState } from 'react';
import Image from 'next/image';
import BannerCard from '../../shared/shared-card/BannerCard';
import moment from 'moment';
import Link from 'next/link';
import axios from 'axios';
import useStorage from '../../../utils/hooks/useStorage';

import * as Scroll from 'react-scroll'; // required for smooth scroll
import {
  Button,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller,
} from 'react-scroll';

import { getStrapiURL } from '../../../lib/api';
import { getImgUrl } from '@utils/functions/getImgUrl';
import CardSuccessStories from './CardSuccessStories';
import { A11y, Grid, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/grid';
import SelectField from '../../../stories/SelectField';
import { customCourseTypeComparator } from '@utils/functions/throttle';

const apiBaseUrl = getStrapiURL();

const SuccessStories = ({ videoTestimonials, textTestimonials, count }) => {
  // get utm from storage
  const { getItem } = useStorage();
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const currentUtm = getItem('utm') && JSON.parse(getItem('utm'));
  const [filter, setFilter] = useState({ domain: '', background: '', workExperience: '' });

  const changeHandler = (e) => {
    const { name, value } = e.target;

    setFilter({
      ...filter,
      [name]: value,
    });
  };

  const FILTER_MAP = {
    background: `&filters[$and][1][background][$eq]=${filter.background}`,
    domain: `&filters[$and][1][domain][$eq]=${filter.domain}`,
    workExperience: `&filters[$and][1][workExperience][$eq]=${filter.workExperience}`,
  };

  // set query string for redirect
  let queryString = '';
  for (const property in currentUtm) {
    queryString += `&${property}=${currentUtm[property]}`;
  }
  const [videos, setVideos] = useState([...videoTestimonials]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const colorArray = [
    '#DDF4EF',
    '#F8ECDE',
    '#FBEAEA',
    '#DDF4EF',
    '#F8ECDE',
    '#FBEAEA',
    '#DDF4EF',
    '#F8ECDE',
    '#FBEAEA',
  ];
  const [page, setPage] = useState(1);

  const scrollTo = () => {
    const slider = document.getElementById('slider');
    slider.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
  };

  const apiCall = async (additionalFilter) => {
    setLoading(true);

    try {
      const res = await axios.get(
        `${apiBaseUrl}/api/testimonials?filters[videoLink][$notNull]=true&filters[rank][$notNull]=true&populate=cardImage&populate=avatar&populate=companyLogo&sort[0]=publishedAt:desc${additionalFilter}`
      );

      const sortedData = customCourseTypeComparator(res.data.data);

      setLoading(false);
      setVideos(sortedData);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // const loadMore = () => {
  //   setPage(page + 1);
  //   apiCall(page + 1);
  // };
  // const showLess = () => {
  //   setPage(1);
  //   apiCall(1);
  // };

  useEffect(() => {
    const filterQuery = Object.entries(filter)
      .reduce((accu, [key, value]) => {
        const query = !!value && FILTER_MAP[key];

        if (typeof query !== 'boolean') {
          accu.push(query);
        }

        return accu;
      }, [])
      .join('');

    if (!filterQuery) {
      return;
    }

    apiCall(filterQuery);
  }, [filter]);

  const resetHandler = () => {
    apiCall('');

    setTimeout(() => {
      setFilter({ domain: '', background: '', workExperience: '' });
    }, 10);
  };

  return (
    <div className="flex flex-col items-center justify-center">
      {/* <BannerCard
        img={'/assets/images/success.png'}
        title="Success Stories"
        desc=" Our learners are the centre of our universe. We take a lot of pride in
          their journey. These stories and testimonials fuel our ambitions at
          AlmaBetter."
        link={queryString ? `courses?${queryString}` : 'courses'}
        buttonText="Explore Courses"
      /> */}
      {count.video > 0 && (
        <h2 className="mt-10 mb-10 ml-2 text-center font-satoshi-bold text-4xl lg:ml-0" id="slider">
          Take a peek into the journeys of our students
        </h2>
      )}
      {/* <Swiper
        modules={[Pagination, A11y, Navigation]}
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 55,
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 55,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        }}
        navigation
        className="!mx-4 !pb-12 lg:!mx-14 lg:!px-6"
        pagination={{ clickable: true }}
      >
        {videos
          ?.sort((a, b) => (a.attributes.rank ?? Infinity) - (b.attributes.rank ?? Infinity))
          ?.map((item, index) => (
            <SwiperSlide key={item.id}>
              <div>
                {' '}
                <h4> HELLO</h4>
              </div>
            </SwiperSlide>
          ))}
      </Swiper> */}{' '}
      <form
        className="mt-4 mb-10 flex w-full flex-wrap items-center gap-y-4 gap-x-4"
        onChange={changeHandler}
      >
        <div className="w-[10rem] md:w-[12rem]">
          <SelectField
            // onChange={({ target }) => {
            //   setuserType(target.value);
            // }}
            name="domain"
            label={null}
            selectStyle="h-9 py-0 bg-transparent !rounded-md"
            required
            defaultValue={filter.domain}
          >
            <option
              data-img_src="assets/images/Placement Statistics/Success Stories/filterButtonIcon.svg"
              selected
              disabled
              hidden
              value=""
            >
              By Domain
            </option>
            <option value="dataScience">Data Science</option>
            <option value="web3">Web Development</option>
          </SelectField>
        </div>

        <div className="w-[12rem]">
          <SelectField
            // onChange={({ target }) => {
            //   setuserType(target.value);
            // }}
            name="background"
            label={null}
            selectStyle="h-9 py-0 bg-transparent !rounded-md"
            required
            defaultValue={filter.background}
          >
            <option
              data-img_src="assets/images/Placement Statistics/Success Stories/filterButtonIcon.svg"
              selected
              disabled
              hidden
              value=""
            >
              By Background
            </option>
            <option value="tech">Engineering</option>
            <option value="nonTech">Non Engineering</option>
          </SelectField>
        </div>

        <div className="w-[12rem]">
          <SelectField
            // onChange={({ target }) => {
            //   setuserType(target.value);
            // }}
            name="workExperience"
            label={null}
            selectStyle="h-9 py-0  md:w-[12rem] bg-transparent !rounded-md"
            required
            defaultValue={filter.workExperience}
          >
            <option
              data-img_src="assets/images/Placement Statistics/Success Stories/filterButtonIcon.svg"
              selected
              disabled
              hidden
              value=""
            >
              By Work Experience
            </option>
            <option value="fresher">Fresher</option>
            <option value="zeroToTwo">0 - 2</option>
            <option value="twoToFive">2 - 5</option>
            <option value="fivePlus">5+</option>
          </SelectField>
        </div>

        {Object.values(filter).some((val) => !!val) && (
          <button
            className="rounded-md border py-0.5 px-6 font-satoshi-medium font-medium  normal-case text-red hover:bg-red hover:text-white md:py-[0.25rem]"
            type="reset"
            onClick={resetHandler}
          >
            Reset
          </button>
        )}
      </form>
      <div className="w-full ">
        <Swiper
          navigation={{
            // Both prevEl & nextEl are null at render so this does not work
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          modules={[Navigation, Pagination, Grid, A11y]}
          pagination={{
            el: '.numbered-swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + (index + 1) + '</span>';
            },
          }}
          onSlideChange={scrollTo}
          // pagination={{ clickable: true }}
          spaceBetween={10}
          grid={{
            rows: 2,
            fill: 'row',
          }}
          breakpoints={{
            320: {
              slidesPerView: 1,
              grid: {
                rows: 4,
              },
              spaceBetween: 20,
              slidesPerGroup: 1,
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 40,
              grid: {
                rows: 3,
              },
              slidesPerGroup: 2,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 40,
              grid: {
                rows: 3,
              },
              slidesPerGroup: 3,
            },
          }}
          className="!pb-16 !pt-8 md:!pt-0 md:!pb-8"
        >
          {videos.map((item, index) => (
            <SwiperSlide key={item.id} className="text-black">
              <CardSuccessStories key={index} item={item} queryString={queryString} />
            </SwiperSlide>
          ))}
          {/* Custom Pagination */}
          <div className="numbered-swiper-pagination  -bottom-4 mt-12 flex items-center justify-center"></div>
          {/* Custom Navigation Buttons */}
          <div className=" flex items-center justify-between">
            <div
              className="flex cursor-pointer gap-x-2 font-satoshi-medium text-gray-navigation hover:text-black"
              ref={navigationPrevRef}
            >
              <img src="assets/images/Placement Statistics/Success Stories/navigation-arrow-left.svg" />
              Prev
            </div>

            <div
              className="flex cursor-pointer gap-x-2 font-satoshi-medium text-gray-navigation hover:text-black"
              ref={navigationNextRef}
            >
              Next
              <img src="assets/images/Placement Statistics/Success Stories/navigation-arrow-right.svg" />
            </div>
          </div>
        </Swiper>
      </div>
      {/* <div className="mx-10 grid items-center gap-6 md:grid-cols-2 lg:mx-0 lg:grid-cols-3">
        {videos.map((item, index) => (
          // <SuccessCard key={index} item={item} queryString={queryString} />
          <CardSuccessStories key={index} item={item} queryString={queryString} />
        ))}
      </div> */}
      {loading && <div className="mt-4">Loading...</div>}
      {/* {videos.length < count.video ? (
        <button
          type="button"
          className="hover:bg-blue-700 focus:bg-blue-700 active:bg-blue-800 mt-8 rounded-md bg-red px-10 py-2 text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg"
          onClick={loadMore}
        >
          Load more
        </button>
      ) : (
        <button
          type="button"
          className="hover:bg-blue-700 focus:bg-blue-700 active:bg-blue-800 mt-8 rounded-md bg-red px-10 py-2 text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg"
          onClick={showLess}
        >
          Show less
        </button>
      )} */}
      {/* {count.text > 0 && (
        <h2 className="mt-20 mb-10 ml-2 text-center lg:ml-0">Testimonials from our Learners</h2>
      )}
      <div className={`mx-10 grid items-center gap-6 lg:mx-0 lg:grid-cols-3`}>
        {textTestimonials.map((item, index) => (
          <TestimonialCard key={index} item={item} bgColor={colorArray[index]} />
        ))}
      </div> */}
    </div>
  );
};

export default SuccessStories;

export const TestimonialCard = ({ bgColor = '#F8ECDE', item }) => {
  const { studentName, studentDesignation, companyLogo, avatar, tagline, slug } = item?.attributes;
  return (
    <div
      className={`bg-[${bgColor}] h-[20rem] max-w-xs cursor-pointer rounded-md hover:shadow-md`}
      style={{ background: bgColor }}
    >
      <div className="m-4 flex h-[18rem] flex-col items-start justify-between rounded-md bg-white p-4">
        <p className="h-32 text-[16px] leading-6 lg:text-[18px]">{tagline}</p>
        <div>
          <div
            className="mt-10 w-full"
            style={{
              border: '0.025rem solid #DCDCDC',
              background: '#DCDCDC',
            }}
          ></div>
          <div className="leading-2 mt-2 flex flex-row items-center justify-start text-base">
            <Image
              src={avatar?.data?.attributes?.url}
              alt=""
              height={80}
              width={80}
              loading="lazy"
              className="rounded-full"
            />
            <div className="mt-2 pl-2">
              <div className="p-0.05 mb-1 font-satoshi-bold text-base font-bold  leading-[20px]">
                <span>{studentName || ''}</span>
              </div>
              <div className="text-[16px] leading-4 text-red">
                <span>{studentDesignation || ''}</span>
              </div>
              <div className="p-0.05 -ml-2 font-satoshi-bold text-sm font-bold  leading-3 text-gray-5">
                <Image
                  src={companyLogo?.data?.attributes?.url}
                  alt=""
                  height={36}
                  width={120}
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export function SuccessCard({ item, queryString }) {
  const {
    studentName,
    studentDesignation,
    videoLink,
    title,
    tagline,
    cardImage,
    slug,
    linkedinUrl,
    avatar,
    companyLogo,
  } = item?.attributes;
  // const date = moment(publishedAt).format('MMMM Do YYYY');
  return (
    <>
      <div
        className={`flex h-fit max-w-md flex-col items-start justify-start overflow-hidden rounded-md  bg-white object-cover shadow-md hover:shadow-lg`}
      >
        <Link
          href={
            queryString ? `/success-stories/${slug}?${queryString}` : `/success-stories/${slug}`
          }
          passHref
        >
          <div className="relative grid h-44 w-full cursor-pointer place-items-center border-r-[12px] border-b-[12px] border-[#F00037] bg-bytes-black-2">
            <img
              src={getImgUrl(avatar)}
              alt={studentName}
              height={250}
              width={448}
              loading="lazy"
              className="-z-1 absolute -right-[0.7rem] -bottom-[0.7rem] h-40 w-40 object-contain"
            />
            <div className="absolute left-4 bottom-[20%]">
              <p className="mb-1 font-satoshi-regular text-sm tracking-wide text-white">
                Placed At
              </p>
              <img
                src={getImgUrl(companyLogo)}
                alt={studentName}
                loading="lazy"
                className="h-9 w-24 rounded-md border-2 border-red bg-white object-contain"
              />
            </div>
          </div>
        </Link>
        {/* <p className='px-4 mt-3 text-xs'>{date}</p> */}
        <div className="flex h-64 flex-col justify-evenly lg:h-52">
          <Link
            href={
              queryString ? `/success-stories/${slug}?${queryString}` : `/success-stories/${slug}`
            }
            passHref
          >
            <div className="my-2 px-4 pt-2 font-satoshi-bold text-[18px] font-bold  leading-[20px] tracking-tight lg:text-[20px] lg:leading-[24px]">
              {title}
            </div>
          </Link>
          <div className="px-4 text-xs font-normal">
            {tagline.slice(0, 100)}
            {tagline.length > 80 && '...'}
          </div>

          <div className="flex flex-row justify-between pr-4">
            <div className="px-4 leading-[20px]">
              <div className="inline-flex items-center justify-center gap-2 font-satoshi-bold text-[16px] font-bold ">
                {studentName || ''}
                <a href={linkedinUrl} target="_blank" rel="noreferrer" className="cursor-pointer">
                  <img src="/assets/icons/courses-icons/LinkedIn@2x.png" alt="" className="w-4" />
                </a>
              </div>
              <div className="mb-4 text-[16px] leading-[20px] text-red">
                {studentDesignation || ''}
              </div>
            </div>
            <p className="break-word mt-1 text-xs tracking-tight text-[#2155DB] lg:mt-0	lg:text-sm">
              <Link
                href={
                  queryString
                    ? `/success-stories/${slug}?${queryString}`
                    : `/success-stories/${slug}`
                }
              >
                Read more
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
